import React, {  useState} from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useChecklist } from '../../context/ChecklistContext';
const API_BASE_URL = 'https://europe-north1-mineral-actor-439113-m9.cloudfunctions.net/wiseclean-backend';

// Доступные зоны с русскими названиями
const availableZones = [
    { id: 'bedroom', name: 'Спальня' },
    { id: 'livingroom', name: 'Гостиная' },
    { id: 'kitchen', name: 'Кухня' },
    { id: 'bathroom', name: 'Ванная' },
    { id: 'hallway', name: 'Прихожая' }
];




// Обязательные зоны для завершения
const requiredZones = ['kitchen', 'bathroom'];

const CheckListSelection = () => {
    const navigate = useNavigate();
    const { orderId } = useParams();
    const { completedZones, addCompletedZone, zoneCounts , zonePhotos } = useChecklist();
    const [loading, setLoading] = useState(false);

    const handleZoneClick = (zoneId, zoneName) => {
        addCompletedZone(zoneId, zoneName);
        const newCount = (zoneCounts[zoneId] || 0) + 1;
        navigate(`/checklist/${orderId}/zone-check/${zoneId}-${newCount}`);
    };

    const isCompletionAvailable = requiredZones.every(zone =>
        completedZones.some((completedZone) => completedZone.id.startsWith(zone))
    );
    // Функция отправки данных на бэкенд
    const handleChecklistSubmit = async () => {
        setLoading(true);


        const checklistData = {
            orderId: orderId,
            zones: completedZones.map(zone => ({
                id: zone.id,
                name: zone.name
            }))
        };

       /* // Добавляем фотографии по зонам
        Object.entries(zonePhotos).forEach(([zoneId, photos]) => {
            photos.forEach((photo, index) => {
                formData.append(`photo-${zoneId}-${index + 1}`, photo);
            });
        });
*/
        try {
            const response = await fetch(`${API_BASE_URL}/submit-checklist`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(checklistData),
            });

            if (!response.ok) {
                throw new Error('Ошибка при отправке чеклиста');
            }

            console.log('Чеклист успешно отправлен');

            // Отправка фотографий
            for (const [zoneId, photoData] of Object.entries(zonePhotos)) {
                const formData = new FormData();
                formData.append('orderId', orderId);
                formData.append('zoneName', zoneId);
                formData.append('photo', photoData.file);
              /*  formData.append('description', photoData.description);*/

                /*const photoResponse =*/ await fetch(`${API_BASE_URL}/upload-photo`, {
                    method: 'POST',
                    body: formData,
                });

                /*if (!photoResponse.ok) {
                    throw new Error(`Ошибка при загрузке фото для зоны ${zoneId}`);
                }*/
            }

            alert('Чеклист и фото успешно отправлены!');
            navigate(`/checklist/${orderId}/summary`);



        } catch (error) {
            console.error('Ошибка при отправке чеклиста:', error);
            alert('Произошла ошибка при отправке данных');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Выберите зоны для проверки</h1>
            <div style={styles.zoneList}>
                {availableZones.map((zone) => (
                    <button
                        key={zone.id}
                        style={{
                            ...styles.zoneButton,
                            backgroundColor: completedZones.some(z => z.id.startsWith(zone.id)) ? '#6CC8D9' : '#000',
                        }}
                        onClick={() => handleZoneClick(zone.id, zone.name)}
                    >
                        {zone.name} {zoneCounts[zone.id] ? `(${zoneCounts[zone.id]})` : ''}
                    </button>
                ))}
            </div>

            <div style={styles.completedZonesContainer}>
                <h3 style={styles.completedHeading}>Проверенные зоны:</h3>
                {completedZones.length > 0 ? (
                    <ul style={styles.zoneListCompleted}>
                        {completedZones.map((zone, index) => (
                            <li key={index} style={styles.zoneItem}>{zone.name}</li>
                        ))}
                    </ul>
                ) : (
                    <p style={styles.noZonesText}>Пока ничего не проверено</p>
                )}
            </div>

            {isCompletionAvailable && (
                <button
                    style={styles.completeButton}
                    onClick={handleChecklistSubmit}
                    disabled={loading}
                >
                    {loading ? 'Отправка...' : 'Завершить проверку'}
                </button>
            )}
        </div>
    );
};

const styles = {
    container: { textAlign: 'center', padding: '20px', maxWidth: '600px', margin: '0 auto' },
    heading: { fontSize: '24px', marginBottom: '20px', color: '#000' },
    zoneList: { display: 'flex', flexDirection: 'column', gap: '15px' },
    zoneButton: {
        width: '100%',
        padding: '20px',
        borderRadius: '8px',
        border: 'none',
        fontSize: '20px',
        color: 'white',
        cursor: 'pointer',
    },
    completedZonesContainer: { marginTop: '30px', textAlign: 'left' },
    completedHeading: { fontSize: '20px', marginBottom: '10px', color: '#000' },
    zoneListCompleted: { listStyleType: 'none', padding: '0' },
    zoneItem: { fontSize: '18px', padding: '5px 0', borderBottom: '1px solid #ccc', color: '#333' },
    noZonesText: { fontSize: '18px', color: '#999' },
    completeButton: {
        width: '100%',
        padding: '20px',
        borderRadius: '8px',
        border: 'none',
        fontSize: '20px',
        color: 'white',
        backgroundColor: '#6CC8D9',
        cursor: 'pointer',
        marginTop: '20px',
    }
};

export default CheckListSelection;
